/* unplugin-vue-components disabled */import script from "./Involved.vue?vue&type=script&setup=true&lang=js"
export * from "./Involved.vue?vue&type=script&setup=true&lang=js"

import "./Involved.vue?vue&type=style&index=0&id=4cd60e42&lang=scss"

const __exports__ = script;

export default __exports__